import React, { useCallback } from "react";
import { Tab, Tabs } from "@bloomberg/media-ui-core";
import typographyStyles from "@bloomberg/media-ui-tokens/css/typography.module.css";
import styles from "./styles.module.css";
import TodayInMarketsSparklineCards from "~components/TodayInMarkets/TodayInMarketsSparklineCards/TodayInMarketsSparklineCards";
import { useTodayInMarkets } from "~context/TodayInMarketsContext";
import type { SparklineCardsProps } from "~types/sectionfront";
import { useTranslateMessage } from "~utils/i18n";

export default function DesktopSparklineCards(props: SparklineCardsProps) {
  const { onChange, selectedOption: selectedOptionId } = props;
  const translate = useTranslateMessage();
  const { categories } = useTodayInMarkets();
  const indexToCategoryId = categories.map((cat) => cat.id);

  const handleTabSwitch = useCallback(
    (_text: string, index?: number) => {
      if (index === null) return;
      const categoryId = indexToCategoryId[index!];

      onChange?.(categoryId);
    },
    [indexToCategoryId, onChange]
  );

  return (
    <>
      <Tabs
        size="default"
        variant="basic"
        className={styles.tabContainer}
        onTabSwitch={handleTabSwitch}
      >
        {categories.map((item) => (
          <Tab
            key={item.id}
            title={translate(item.label)}
            isDefault={selectedOptionId === item.id}
            // className={styles.test}
          >
            {""}
          </Tab>
        ))}
      </Tabs>

      <div className={styles.tabGridContainer}>
        <TodayInMarketsSparklineCards enableFocusEvents />
      </div>
    </>
  );
}
